import { render, staticRenderFns } from "./Vipps.vue?vue&type=template&id=1e30d0f4"
import script from "./Vipps.vue?vue&type=script&lang=js"
export * from "./Vipps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports